module.exports = __webpack_public_path__ + "media/images/places/black_add-070baa6de11ef8749459123fb450cb59.png";